import React from 'react'

import { AccounHeader } from 'scenes/account/AccountMainMenu'
import BaseSceneAlbum from 'scenes/baseAlbumScene'


export default function SceneAlbum() {
  const query = [
    'albums',
    'mine',
  ]

  return <BaseSceneAlbum
    headers={
      <AccounHeader />
    }
    query={query}
    baseRedirect='/account/albums'
    baseRedirectEmpty='/account/albums'
  />
}
